import styles from "@css/modules/Listings.module.scss"
import { SortTooltip } from "@components/Listings/SortTooltip"
import { pointOnContractYearsString } from "@components/Listings/listings-page-utils"
import { SortBtn } from "@components/Listings/SortBtn"
import { MouseEventHandler } from "react"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"

type Props = {
    resort?: boolean
}

export function ListingItemsHeader({ resort }: Props) {
    const headerSort: MouseEventHandler<HTMLDivElement> = (e) => {
        let columnKey = e.currentTarget.dataset.field
        const initialSort = e.currentTarget.dataset.sort || "asc"
        const secondSort = initialSort === "asc" ? "desc" : "asc"
        const [column, direction] = useFilterStore.getState().sort.split(":")
        const sameDirection = direction === initialSort
        const sameColumn = columnKey === column
        const order = sameColumn ? (sameDirection ? secondSort : initialSort) : initialSort

        if (columnKey === "resort") {
            columnKey = "resort.short_name"
        }
        let sort = ""
        if (order) {
            const direction = order || "desc"
            sort = `${columnKey}:${direction}`
        }
        useFilterStore.getState().updateSort(sort)
    }
    return (
        <div className={styles.tableHeader}>
            <SortTooltip current={"resort.short_name"}>
                <div onClick={resort ? undefined : headerSort} data-field="resort.short_name" className={styles.resortCell}>
                    Resort
                </div>
            </SortTooltip>
            <SortTooltip current={"points_on_contract"}>
                <div onClick={headerSort} data-field="points_on_contract" className={styles.pointsOnCell}>
                    Pts.
                </div>
            </SortTooltip>
            <div className={styles.pointsCell}>
                Pts. Available
                <br />
                {pointOnContractYearsString}
            </div>
            {/*<SortTooltip {...filtersState.sort} text="Click to sort by current year" current={"current_year_points"}>*/}
            {/*onClick={headerSort} data-field="current_year_points"*/}
            {/*</SortTooltip>*/}
            <SortTooltip current={"price_per_point"}>
                <div onClick={headerSort} data-field="price_per_point" className={styles.pppCell}>
                    $/pt.
                </div>
            </SortTooltip>
            <SortTooltip current={"use_month"}>
                <div onClick={headerSort} data-field="use_month" className={styles.useCell}>
                    Month
                </div>
            </SortTooltip>
            <SortTooltip current={"price"}>
                <div onClick={headerSort} data-field="price" className={styles.priceCell}>
                    Price
                </div>
            </SortTooltip>
            <div className={styles.statusCell}>Status</div>
            <SortTooltip current={"stars"} startOrder="descending">
                <div onClick={headerSort} data-field="stars" data-sort="desc" className={styles.starsCell}>
                    Deal score
                </div>
            </SortTooltip>
            <SortTooltip current={"parsed_date"}>
                <div onClick={headerSort} data-field="parsed_date" className={styles.ageCell}>
                    Age
                </div>
            </SortTooltip>
            <div className={styles.favoriteCell}>
                <SortBtn resortSorting={!!resort} placement="bottomLeft" />
            </div>
        </div>
    )
}
